import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path: string = "content-pdpa";

export class ContentPDPAApi extends BaseAPI {

  static findOne(): Promise<AxiosResponse> {
    return this.api.get(`${path}/get-one`);
  }
  static create(body: any): Promise<AxiosResponse> {
    return this.api.post(`${path}`, body);
  }
}
